import React, {useCallback, useContext, useEffect, useState} from "react"
import Column from "@amzn/meridian/column";
import Row from "@amzn/meridian/row";
import Link from "@amzn/meridian/link";
import Select, {SelectOption} from "@amzn/meridian/select";
import Text from "@amzn/meridian/text";
import {PickFilterContext} from "./context/PickFilterContext";
import Tag from "@amzn/meridian/tag";
import {FormattedMessage, injectIntl} from "react-intl";
import Popover, {PopoverHeader} from "@amzn/meridian/popover";
import ControlGroup from "@amzn/meridian/control-group";
import Checkbox from "@amzn/meridian/checkbox";
import * as PickColumns from "./PickTableColumns";
import {
    getAisleGroupStatusList,
    getPickStationStatusListARv2,
    getPickStatusInGridList,
    getPickStatusList,
    getPickStatusListARv2
} from "../util/EntityStatusManager";
import ExportCSV from "../exportcsv/ExportCSV";
import {getPickDataInCSVFormat} from "../util/ExportUtils";
import {PickContext} from "./context/PickContext";
import {CapabilityContext} from "../global/context/CapabilityContext";
import {AR_V2, BOOLEAN, CORE_AMZL} from "../util/Constants";
import Input from "@amzn/meridian/input";
import {getFilterTagLabel} from "../util/FilterUtil";
import RefreshTimer from "../util/RefreshTimer";
import {PickViewSelectorContext} from "./context/PickViewSelectorContext";
import {PICK_VIEWS} from "./constants/Constants";
import {showKeyForViewState} from "./model/PickFilter";

const PickFilterViewV2 = (props) => {
    const {viewModelF, dispatchF} = useContext(PickFilterContext);
    const {configViewModel} = useContext(CapabilityContext);
    const {viewModel} = useContext(PickContext);
    const {viewState} = useContext(PickViewSelectorContext);

    const [viewOptionVisible, setViewOptionVisible] = useState(false);
    const onClickViewOptionButton = useCallback(() => setViewOptionVisible(true), [])
    const onCloseViewOptionButton = useCallback(() => setViewOptionVisible(false), [])
    const optionButtonRef = React.useRef();

    const headersToStringId = [
        {value: 'pickStatus.stageByTime', header: PickColumns.STAGE_BY_TIME},
        {value: 'pickStatus.priority', header: PickColumns.PRIORITY},
        {value: 'pickStatus.routeId', header: PickColumns.ROUTE_ID},
        {value: 'pickStatus.station', header: PickColumns.STATION},
        {value: 'pickStatus.status', header: PickColumns.STATUS},
        {value: 'pickStatus.bags', header: PickColumns.BAGS},
        {value: 'pickStatus.ovPackages', header: PickColumns.OVS},
        {value: 'pickStatus.aisles', header: PickColumns.AISLES},
        {value: 'pickStatus.spr', header: PickColumns.SPR},
        {value: 'pickStatus.progress', header: PickColumns.PROGRESS},
        {value: 'pickStatus.associate', header: PickColumns.ASSOCIATE},
        {value: 'pickStatus.duration', header: PickColumns.DURATION},
        {value: 'pickStatus.type', header: PickColumns.TYPE}
    ];

    const headersToStringIdMultiStationPick = [
        {value: 'pickStatus.stageByTime', header: PickColumns.STAGE_BY_TIME},
        {value: 'pickStatus.priority', header: PickColumns.PRIORITY},
        {value: 'pickStatus.routeId', header: PickColumns.ROUTE_ID},
        {value: 'pickStatus.station', header: PickColumns.STATION},
        {value: 'pickStatus.status', header: PickColumns.STATUS},
        {value: 'pickStatus.bags', header: PickColumns.BAGS},
        {value: 'pickStatus.ovPackages', header: PickColumns.OVS},
        {value: 'pickStatus.aisles', header: PickColumns.AISLES},
        {value: 'pickStatus.assignedWorkGroups', header: PickColumns.ASSIGNED_WORK_GROUP},
        {value: 'pickStatus.nextWorkGroups', header: PickColumns.NEXT_WORK_GROUPS},
        {value: 'pickStatus.spr', header: PickColumns.SPR},
        {value: 'pickStatus.progress', header: PickColumns.PROGRESS},
        {value: 'pickStatus.associate', header: PickColumns.ASSOCIATE},
        {value: 'pickStatus.duration', header: PickColumns.DURATION},
        {value: 'pickStatus.type', header: PickColumns.TYPE}
    ];

    const headersToStringIdARv2 = [
        {value: 'pickStatus.pick_by_time', header: PickColumns.PICK_BY_TIME},
        {value: 'pickStatus.routeId', header: PickColumns.ROUTE_ID},
        {value: 'pickStatus.stationPairs', header: PickColumns.STATION_PAIRS},
        {value: 'pickStatus.status', header: PickColumns.STATUS},
        {value: 'pickStatus.carts', header: PickColumns.CARTS},
        {value: 'pickStatus.spr', header: PickColumns.SPR},
        {value: 'pickStatus.progress', header: PickColumns.PROGRESS},
        {value: 'pickStatus.associate', header: PickColumns.ASSOCIATE},
        {value: 'pickStatus.duration', header: PickColumns.DURATION},
        {value: 'pickStatus.type', header: PickColumns.TYPE},
        {value: 'pickStatus.lastPick', header: PickColumns.LAST_PICK},
    ];

    useEffect(() => {
        dispatchF({type: 'LOAD_FILTERS'});
        dispatchF({
            type: 'LOAD_XPT_NODES',
            data: {
                dispatcher: dispatchF,
                baseUrl: configViewModel.baseUrl,
                capability: configViewModel.capability,
                stationConfig: configViewModel.stationConfig
            }
        });
        dispatchF({type: 'LOAD_PICK_COLUMNS', data: {capability: configViewModel.capability}});
    }, []);

    useEffect(() => {
        if (viewState === PICK_VIEWS.LAYOUT_GRID_VIEW) {
            dispatchF({type: 'SELECT_WAVE_PLUS_X', wavePluxXEnabled: true});
        }
    }, [viewState]);

    const setViewOptionColumns = (newValue) => {
        dispatchF({
            type: 'SET_PICK_COLUMNS', data: {
                newValue: newValue,
                capability: configViewModel.capability
            }
        });
    }

    const displayViewOptions = () => {
        let headersToStringMapping;
        if (configViewModel.capability === AR_V2) {
            headersToStringMapping = headersToStringIdARv2;
        } else if (configViewModel.stationConfig.initialised &&
            configViewModel.stationConfig.multiStationPicklistViewEnabled) {
            headersToStringMapping = headersToStringIdMultiStationPick;
        } else {
            headersToStringMapping = headersToStringId;
        }

        return [headersToStringMapping.map(entry => {
            return <Checkbox disabled={entry.header === PickColumns.ROUTE_ID} value={entry.header}>
                {props.intl.formatMessage({
                    id: entry.value,
                    defaultMessage: entry.header
                })}
            </Checkbox>;
        })];
    }

    const pickDataConversionHandler = () => {
        return getPickDataInCSVFormat(viewModel.routeList, configViewModel.capability, configViewModel.stationConfig);
    }

    const isFilterSet = (viewState, configViewModel) => {
        let result = false;
        Object.entries(viewModelF).forEach(entry => {
            const key = entry[0];
            const values = entry[1];
            result = result || (Array.isArray(values) && values.length && key !== 'data'
                && key !== 'selectedPickColumns' && showKeyForViewState(key, viewState, configViewModel));
        });
        return result;
    }

    const clearAllFilters = () => {
        dispatchF({type: 'REMOVE_ALL_FILTER'});
    }

    const isXPTFilterRequired = () => {
        const xptNodes = viewModelF.data.xptNodes;
        return Array.isArray(xptNodes) && xptNodes.length && configViewModel.capability === CORE_AMZL;
    }

    const renderPickByTimeFilter = () => {
        return (
            <Select
                onChange={(data) => dispatchF({type: 'SELECT_PICK_BY_TIME', PickByTimes: data})}
                value={viewModelF.pickByTime}
                size="small"
                placeholder={props.intl.formatMessage({
                    id: "pickStatus.pick_by_time",
                    defaultMessage: "Pick by time"
                })}
                width={"145px"}>
                {[...viewModelF.data.pickByTime].map(pickByTime => (
                    <SelectOption key={pickByTime} label={"Pick by " + pickByTime}
                        value={pickByTime} />
                ))}
            </Select>
        );
    }

    const renderRouteStatusFilter = (pickStatusValuesList) => {
        return (
            <Select
                onChange={(data) => dispatchF({type: 'SELECT_ROUTE_STATUS', routeStatus: data})}
                value={viewModelF.routeStatus}
                size="small"
                placeholder={props.intl.formatMessage({id: "pickfilter.routestatus", defaultMessage: "Route status"})}
                width={"132px"}>
                {pickStatusValuesList.map(status => (
                    <SelectOption key={status} label={status} value={status} />
                ))}
            </Select>
        );
    }

    const renderLastPickRouteCutFilter = () => {
        return (
            <Row alignmentHorizontal="right" spacingInset={"none none none medium"} spacing={"small"}>
                <Text>
                    <FormattedMessage id="pickStatus.lastPick" defaultMessage="Last pick" />:
                </Text>
                <Input type="number"
                    size="small"
                    width="105px"
                    value={viewModelF.rcTimeLimit}
                    onChange={(data) => dispatchF({type: 'SELECT_RC_TIME_LIMIT', rcTimeLimit: data})}
                    placeholder="0"
                    suffix={"mins"} />
                <Text>
                    <FormattedMessage id="outboundARv2.rc.packageThreshold" defaultMessage="Packages cut" />:
                </Text>
                <Input type="number"
                    size="small"
                    width="105px"
                    value={viewModelF.rcPackageCount}
                    onChange={(data) => dispatchF({type: 'SELECT_RC_PACKAGE_COUNT', rcPackageCount: data})}
                    placeholder="0"
                    suffix={"pkgs"} />
            </Row>
        );
    }

    const renderPickStationFilter = () => {
        return (
            <Select
                onChange={(data) => dispatchF({type: 'SELECT_PICK_STATION', pickWorkstations: data})}
                value={viewModelF.pickWorkstations}
                size="small"
                placeholder={props.intl.formatMessage({id: "pickfilter.pickStation", defaultMessage: "Pick station"})}
                width={"145px"}>
                {[...viewModelF.data.pickWorkstations].map(station => (
                    <SelectOption key={station} label={station}
                        value={station} />
                ))}
            </Select>
        );
    }

    const renderStationStatusFilter = (stationStatusValuesList) => {
        return (
            <Select
                onChange={(data) => dispatchF({type: 'SELECT_WORKSTATION_STATUS', workstationStatus: data})}
                value={viewModelF.workstationStatus}
                size="small"
                placeholder={props.intl.formatMessage({id: "pickfilter.pickStationStatus", defaultMessage: "Station status"})}
                width={"145px"}>
                {stationStatusValuesList.map(status => (
                    <SelectOption key={status} label={status} value={status} />
                ))}
            </Select>
        );
    }


    const getFilterDropDownMenu = () => {
        if (configViewModel.capability === AR_V2) {
            return (
                <Column width="100%" spacing={"none"}>
                    <Row width="100%" spacing="small" spacingInset="none" wrap={"down"}>
                        <Text alignment="left">
                            <FormattedMessage id="pick.filters" defaultMessage="Filters:" />
                        </Text>
                        {viewState === PICK_VIEWS.ROUTE_VIEW && renderPickByTimeFilter()}
                        {viewState === PICK_VIEWS.ROUTE_VIEW && renderRouteStatusFilter(getPickStatusListARv2())}
                        {viewState === PICK_VIEWS.ROUTE_VIEW && renderLastPickRouteCutFilter()}
                        {viewState === PICK_VIEWS.WORKSTATION_VIEW && renderPickStationFilter()}
                        {viewState === PICK_VIEWS.WORKSTATION_VIEW && renderStationStatusFilter(getPickStationStatusListARv2())}
                    </Row>
                </Column>
            )
        }

        return (
            <Column width="100%" spacking={"none"}>
                <Row width="100%" spacing="small" spacingInset="none" wrap={"down"}>
                    {isXPTFilterRequired() ?
                        <Select
                            onChange={(data) => dispatchF({type: 'SELECT_XPT_NODE', xptNodes: data})}
                            value={viewModelF.xptNodes}
                            size="small"
                            placeholder={props.intl.formatMessage({id: "pick.xptNodes", defaultMessage: "XPT Nodes"})}
                            width={"120px"}>
                            {[...viewModelF.data.xptNodes].sort().map(xptNode => (
                                <SelectOption key={xptNode} label={xptNode} value={xptNode} />
                            ))}
                        </Select>
                        : null
                    }
                    {viewState === PICK_VIEWS.ROUTE_VIEW ? <Select
                            onChange={(data) => dispatchF({type: 'SELECT_DEPARTURE', Departure: data})}
                            value={viewModelF.departure}
                            size="small"
                            placeholder={props.intl.formatMessage({
                                id: "pick.stageByTime",
                                defaultMessage: "Stage by time"
                            })}
                            width={"145px"}>
                            {[...viewModelF.data.departure].sort().map(departure => (
                                <SelectOption key={departure} label={"Stage by " + departure}
                                              value={departure}/>
                            ))}
                        </Select>
                        : null
                    }
                    {viewState === PICK_VIEWS.ROUTE_VIEW ? <Select
                            onChange={(data) => dispatchF({type: 'SELECT_DRIVER_TYPE', DriverType: data})}
                            value={viewModelF.driverType}
                            size="small"
                            placeholder={props.intl.formatMessage({
                                id: "pickfilter.driverType",
                                defaultMessage: "Driver Type"
                            })}
                            width={"125px"}>
                            {[...viewModelF.data.driverType].sort().map(driverType => (
                                <SelectOption key={driverType} label={driverType} value={driverType}/>
                            ))}
                        </Select>
                        : null
                    }
                    {viewState === PICK_VIEWS.ROUTE_VIEW ? <Select
                            onChange={(data) => dispatchF({type: 'SELECT_CLUSTER', Cluster: data})}
                            value={viewModelF.cluster}
                            size="small"
                            placeholder={props.intl.formatMessage({id: "pickfilter.cluster", defaultMessage: "Cluster"})}
                            width={"115px"}>
                            {[...viewModelF.data.cluster].sort().map(cluster => (
                                <SelectOption key={cluster} label={cluster} value={cluster}/>
                            ))}
                        </Select>
                        : null
                    }
                    {viewState === PICK_VIEWS.ROUTE_VIEW ? renderRouteStatusFilter(getPickStatusList(configViewModel.stationConfig)) : null}
                    {viewState === PICK_VIEWS.ROUTE_VIEW && configViewModel.stationConfig.parallelPickEnabled ?
                        <Select
                            onChange={(data) => dispatchF({type: 'SELECT_PICKLIST_STATUS', picklistStatus: data})}
                            value={viewModelF.picklistStatus}
                            size="small"
                            placeholder={props.intl.formatMessage({
                                id: "pickfilter.picklistStatus",
                                defaultMessage: "Picklist status"
                            })}
                            width={"135px"}>
                            {getPickStatusList(configViewModel.stationConfig).map(status => (
                                <SelectOption key={status} label={status} value={status} />
                            ))}
                        </Select>
                        : null
                    }
                    {viewState === PICK_VIEWS.ROUTE_VIEW ?
                        <Row>
                            <Row alignmentHorizontal="left" spacingInset={"none none none small"} spacing={"small"}>
                                <Text>
                                    <FormattedMessage id="pick.sprThresholds" defaultMessage="SPR thresholds"/>:
                                </Text>
                                <Input type="number"
                                       size="small"
                                       width="105px"
                                       placeholder={props.intl.formatMessage({id: "pick.time", defaultMessage: "Time"})}
                                       value={viewModelF.sprTimeLimit}
                                       onChange={(data) => dispatchF({type: 'SELECT_SPR_TIME_LIMIT', sprTimeLimit: data})}
                                       suffix={"mins"}/>
                                <Input type="number"
                                       size="small"
                                       width="60px"
                                       value={viewModelF.sprPackageCount}
                                       onChange={(data) => dispatchF({
                                           type: 'SELECT_SPR_PACKAGE_COUNT',
                                           sprPackageCount: data
                                       })}
                                       placeholder={props.intl.formatMessage({id: "pick.spr", defaultMessage: "SPR"})}
                                />
                            </Row>
                            < Checkbox
                                key = "highSPR"
                                name="highSPR"
                                onChange={(data) => dispatchF({type: 'SELECT_ROUTE_SPR', highSPREnabled: data})}
                                checked={viewModelF.routeSPR.includes('High SPR')}>
                                <FormattedMessage id="pick.highSPR" defaultMessage="High SPR" />
                            </Checkbox>
                            <Checkbox
                                key="atRisk"
                                name="atRisk"
                                onChange={(data) => dispatchF({type: 'SELECT_AT_RISK', atRiskEnabled: data})}
                                checked={viewModelF.atRisk.includes(BOOLEAN.TRUE)}>
                                <FormattedMessage id="pick.atRisk" defaultMessage="At Risk" />
                            </Checkbox>

                            {configViewModel.capability === CORE_AMZL && configViewModel.stationConfig.multiStationPicklistViewEnabled ? (
                                <Checkbox
                                    key="multiStationPicklists"
                                    name="multiStationPicklists"
                                    onChange={(data) => dispatchF({type: 'SELECT_MULTI_STATION_PICKLIST', multiStationPicklistEnabled: data})}
                                    checked={viewModelF.multiStationPicklists.includes(BOOLEAN.TRUE)}>
                                    <FormattedMessage id="pick.multiStationPicklists" defaultMessage="Multi Station Picklist" />
                                </Checkbox>
                                )
                                : null}
                        </Row>
                        : null
                    }
                    {viewState === PICK_VIEWS.LAYOUT_GRID_VIEW ?
                        <Select
                            onChange={(data) => dispatchF({type: 'SELECT_AISLE_GROUP_STATUS', aisleGroupStatus: data})}
                            value={viewModelF.aisleGroupStatus}
                            size="small"
                            placeholder={props.intl.formatMessage({
                                id: "pick.aisleGroupStatusFilter",
                                defaultMessage: "Aisle group status"
                            })}
                            width={"180px"}>
                            {getAisleGroupStatusList().map(status => (
                                <SelectOption key={status} label={status} value={status} />
                            ))}
                        </Select>
                        : null
                    }
                    {viewState === PICK_VIEWS.LAYOUT_GRID_VIEW ?
                        <Select
                            onChange={(data) => dispatchF({type: 'SELECT_PICKLIST_STATUS_IN_GRID', picklistStatusInGrid: data})}
                            value={viewModelF.picklistStatusInGrid}
                            size="small"
                            placeholder={props.intl.formatMessage({
                                id: "pick.picklistStatusInGridFilter",
                                defaultMessage: "Picklist status in grid"
                            })}
                            width={"200px"}>
                            {getPickStatusInGridList().map(status => (
                                <SelectOption key={status} label={status} value={status} />
                            ))}
                        </Select>
                        : null
                    }
                    {viewState === PICK_VIEWS.LAYOUT_GRID_VIEW ?
                        <Row spacingInset={"none none none medium"} spacing={"small"}>
                            <Checkbox
                            key="wavePlusXPicklists"
                            name="wavePlusXPicklists"
                            onChange={(data) => dispatchF({type: 'SELECT_WAVE_PLUS_X', wavePluxXEnabled: data})}
                            checked={viewModelF.wavePluxXEnabled.includes(BOOLEAN.TRUE)}>
                            <FormattedMessage id="pick.wavePlusXPicklistsFilter" defaultMessage="Wave+X Picklist" />
                        </Checkbox>

                        {configViewModel.capability === CORE_AMZL && configViewModel.stationConfig.multiStationPicklistViewEnabled ? (
                                <Checkbox
                                    key="multiStationPicklists"
                                    name="multiStationPicklists"
                                    onChange={(data) => dispatchF({type: 'SELECT_MULTI_STATION_PICKLIST', multiStationPicklistEnabled: data})}
                                    checked={viewModelF.multiStationPicklists.includes(BOOLEAN.TRUE)}>
                                    <FormattedMessage id="pick.multiStationPicklists" defaultMessage="Multi Station Picklist" />
                                </Checkbox>
                            )
                            : null}
                        </Row>
                        : null
                    }
                </Row>
            </Column>
        )
    };

    const renderTableOptionsAndExportToCSV = () => {
        return (
            <Row width="100%" spacingInset="none" alignmentHorizontal={"right"} >
                <Link data-test-id="tableOptionsLink" type="secondary" onClick={onClickViewOptionButton}
                    ref={optionButtonRef}>
                    <FormattedMessage id="pick.tableOptions" defaultMessage="Table Options" />
                </Link>
                <Popover anchorNode={optionButtonRef.current} open={viewOptionVisible}
                    onClose={onCloseViewOptionButton} position="right" alignment="center">
                    <PopoverHeader closeLabel="Close">
                        <FormattedMessage id="pickfilter.available_columns"
                            defaultMessage="Available Columns" />
                    </PopoverHeader>
                    <div style={{"overflowX": "scroll", "maxHeight": "300px"}}>
                        <ControlGroup onChange={setViewOptionColumns}
                            value={viewModelF.selectedPickColumns}>
                            {
                                displayViewOptions()
                            }
                        </ControlGroup>
                    </div>
                </Popover>
                    <ExportCSV isLink={true} csvDataProvider={pickDataConversionHandler} filePrefix={"PICK"} />
            </Row>
        );
    }

    const renderFilterTags = () => {
        return (
            <Row width="100%" spacingInset="small none none none">
                <Row spacing={"small"}>
                    {Object.entries(viewModelF).map(entry => {
                        const key = entry[0]
                        const values = entry[1]
                        return (
                            (Array.isArray(values) && key !== 'data' && key !== 'selectedPickColumns')
                                && showKeyForViewState(key, viewState, configViewModel) ?
                                values.map(value => {
                                    return <Tag key={value} type="theme"
                                        onClose={() => dispatchF({
                                            type: 'REMOVE_FILTER',
                                            data: {key, value}
                                        })}>{getFilterTagLabel(key, value)}</Tag>
                                }) : null
                        )
                    })}
                    {isFilterSet(viewState, configViewModel) ?
                        <Link onClick={clearAllFilters} type="secondary">
                            <FormattedMessage id="pickfilter.clearAll" defaultMessage="Clear all" />
                        </Link>
                        : null
                    }
                </Row>
            </Row>
        );
    }

    return (
        <Column spacing={"none"}>
            {(configViewModel.capability !== AR_V2 || viewState !== PICK_VIEWS.WORKSTATION_VIEW)
            && viewState !== PICK_VIEWS.LAYOUT_GRID_VIEW ?
                renderTableOptionsAndExportToCSV()
                : null
            }
            <Row width="100%" spacingInset="medium small" spacing="small" backgroundColor="secondary">
                {getFilterDropDownMenu()}
            </Row>
            {renderFilterTags()}
            <Row spacingInset="small none">
                <RefreshTimer deps={[viewModel.lastUpdated]} lastUpdated={viewModel.lastUpdated} />
            </Row>
        </Column>
    )
}

export default injectIntl(PickFilterViewV2);


// WEBPACK FOOTER //
// ./src/components/pickStatus/PickFilterViewV2.js